import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import DisplayDate from "components/DisplayDate";
import { differenceInDays } from "date-fns";
import React from "react";
import { useNavigate } from "react-router-dom";
import { getStatus } from "utils/utils";

const DuplicateDataAlertModal = ({ open, onClose, message, data, onSuccess }) => {
  const navigate = useNavigate();
  const isDeadlinePassed = (taskDetails) => {
    const daysUntilDeadline = differenceInDays(new Date(taskDetails?.deadline), new Date());
    if (taskDetails?.status === "COMPLETED" || taskDetails?.status === "CANCELLED") {
      return false;
    } else {
      return { days: daysUntilDeadline + 1, isPassed: daysUntilDeadline < 0 };
    }
  };
  return (
    <div>
      <Dialog open={open} onClose={onClose} maxWidth="2xl">
        <DialogTitle className="font-bold uppercase">{message}</DialogTitle>
        <hr />
        <DialogContent>
          <div>
            <table>
              <thead>
                <tr className="border-b border-app-border">
                  <th className="text-left border-r p-2 ">SN</th>
                  <th className="text-left border-r p-2 ">Client Name</th>
                  <th className="text-left border-r p-2 ">Module</th>
                  <th className="text-left border-r p-2 ">Assigned By</th>
                  <th className="text-left border-r p-2 ">Assigned To</th>
                  <th className="text-left border-r p-2 ">Priority</th>
                  <th className="text-left border-r p-2 ">Created Date</th>
                  <th className="text-left border-r p-2 ">Deadline</th>
                  <th className="text-left border-r p-2 ">Status</th>
                </tr>
              </thead>

              {data
                ?.filter((item) => item?.status !== "COMPLETED" && item?.status !== "CANCELLED")
                ?.map((item, index) => (
                  <tr className="border-b border-app-border p-2" key={item?.id}>
                    <td className="border-r p-2">{index + 1}</td>
                    <td className="border-r p-2">{item?.clientName}</td>
                    <td className="border-r p-2">{item?.module}</td>
                    <td className="border-r p-2">{item?.assignedBy?.name}</td>
                    <td className="border-r p-2">{item?.assignedTo?.name}</td>
                    <td className="border-r p-2 capitalize">{item?.priority}</td>
                    <td className="border-r p-2">
                      <DisplayDate value={item?.createdDate ?? item?.createdAt} />
                    </td>
                    <td className="border-r p-2">
                      <div
                        className="flex flex-col items-start max-w-[150px] truncate"
                        style={
                          isDeadlinePassed(item)?.isPassed
                            ? { color: "var(--app-priority-high-text)" }
                            : undefined
                        }
                      >
                        <DisplayDate value={item?.deadline} />
                        {isDeadlinePassed(item)?.days > 0 && (
                          <span className="text-xs text-app-text-secondary">
                            {isDeadlinePassed(item)?.days}
                            day{isDeadlinePassed(item)?.days > 1 ? "s" : ""} left
                          </span>
                        )}
                        {isDeadlinePassed(item)?.days <= 0 && (
                          <span
                            className="text-xs"
                            style={{ color: "var(--app-priority-high-text)" }}
                          >
                            Deadline already passed.
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="border-r p-2">{getStatus(item?.status)}</td>
                    <td className="border-r p-2">
                      <Button
                        onClick={() => {
                          navigate(`/admin/tasks/view/${item?.id}`);
                          onClose();
                        }}
                        variant="outlined"
                        color="primary"
                      >
                        View Details
                      </Button>
                    </td>
                  </tr>
                ))}
            </table>
          </div>
        </DialogContent>
        <hr />
        <DialogActions>
          <Button onClick={onClose} variant="outlined" color="primary">
            No
          </Button>
          <Button onClick={onSuccess} variant="contained" color="primary">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DuplicateDataAlertModal;
